import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { EoFormComponent, STATUS } from 'ngx-eo-web-components';
import { filter, Subscription } from 'rxjs';
import {
  getAvailabilityValue,
  surgeryAssignFormConfig,
} from '../../config/surgery-assign-form.config';
import { AuthService } from '../../../../services/auth/auth.service';
import { CoreService } from '../../../core/core.service';
import { HospitalAvailabilityService } from '../../../../services/hospitalAvailability/hospitalAvailability.service';
import { SurgeryIdikaService } from '../../../../services/surgery-idika/surgery-idika.service';
import { IdikaSurgery } from '../../../core/models/idika-surgery.model';
import { months } from '../../../shared/components/month-dropdown/month-dropdown.config';
import { generateYearOptions } from '../../../shared/components/year-options/year-options.config';
import { HospitalAvailability } from '../../../core/models/hospital-availability.model';
import { Message } from 'primeng/api';
import { SurgeryAssignmentService } from '../../../../services/surgery-assignment/surgery-assignment.service';

@Component({
  selector: 'app-surgery-assign-form-dialog',
  templateUrl: './surgery-assign-form-dialog.component.html',
  styleUrls: ['./surgery-assign-form-dialog.component.scss'],
})
export class SurgeryAssignFormDialogComponent {
  constructor(
    private surgeryIdikaService: SurgeryIdikaService,
    private coreService: CoreService,
    private hospitalAvailabilityService: HospitalAvailabilityService,
    private surgeryAssignmentService: SurgeryAssignmentService
  ) {}

  messages: Message[] = [];

  hospitalAvailabilities: HospitalAvailability[] | null = null;

  months = months;
  generateYearOptions = generateYearOptions;

  subscriptions: Subscription[] = [];
  @ViewChild('surgeryAssignForm', { static: false })
  surgeryAssignForm?: EoFormComponent;

  idikaSurgery?: IdikaSurgery;
  hospitalId?: string | null;
  remainingSurgeryCount = 0;
  visible = false;
  formConfig = [...surgeryAssignFormConfig];

  @Output() success = new EventEmitter();

  ngOnInit(): void {
    this.subscriptions = [this.getIdikaSurgeryAssignSuccessSub$()];
  }

  getAvailabilityValue() {
    return getAvailabilityValue();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onSubmit($event: any) {
    if (!$event?.surgeryAssignForm) return;

    let surgeryAssignBind = {
      hospitalID: this.hospitalId ?? '',
      surgeryIdikaListItemID: this.idikaSurgery?.id ?? '',
      hospitalAvailabilityID: $event?.surgeryAssignForm.availability,
    };

    this.surgeryIdikaService.assignSurgery(surgeryAssignBind).subscribe();
  }

  onSubmitSuccess(): void {
    this.surgeryIdikaService.init();
    this.visible = false;
    this.showSuccessMessage();
    this.success.emit();
  }

  showSuccessMessage(): void {
    this.coreService.showSuccess('Η ανάθεση ολοκληρώθηκε με επιτυχία');
  }

  setFcValue(formControlName: string, value: any) {
    return this.surgeryAssignForm?.setValue(
      'surgeryAssignForm',
      formControlName,
      value
    );
  }

  getFormConfig() {
    return this.formConfig;
  }

  getHeader(): string {
    return 'Ανάθεση Χειρουργείου';
  }

  initForm() {
    this.surgeryAssignForm?.form.reset();
    this.surgeryAssignForm?.form.enable();

    if (this.idikaSurgery) {
    }
  }

  getIdikaSurgeryAssignSuccessSub$() {
    return this.surgeryIdikaService.surgeryAssignCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  isSubmitLoading(): boolean {
    let sAssignStatus =
      this.surgeryIdikaService.surgeryAssignCallHandler?.status$?.getValue();
    if (sAssignStatus === STATUS.loading) return true;

    return false;
  }

  isLoading(): boolean {
    let haListStatus =
      this.hospitalAvailabilityService.hospitalAvailabilityListByHospitalCallHandler?.status$?.getValue();
    if (haListStatus === STATUS.loading) return true;

    let saStatus =
      this.surgeryAssignmentService.surgeryAssignmentFetchCallHandler?.status$?.getValue();
    if (saStatus === STATUS.loading) return true;

    return false;
  }

  onAvailabilityChange(event: any): void {
    // Find the hospital availability based on event.value (which is the ID)
    const hospitalAvailability = this.hospitalAvailabilities?.find(
      (availability) => availability.id === event.value
    );

    // Add your logic here
    if (this.hospitalId && hospitalAvailability) {
      this.remainingSurgeryCount = hospitalAvailability.slots;
      this.surgeryAssignmentService
        .getSurgeriesCount(
          this.hospitalId,
          hospitalAvailability.availabilityMonth,
          hospitalAvailability.availabilityYear
        )
        .subscribe((data) => {
            const surgeryCount = data ?? 0;
            //console.log('Surgery count:', surgeryCount);
            this.remainingSurgeryCount = Math.max(hospitalAvailability.slots - surgeryCount, 0);
            //console.log('Remaining surgery count:', this.remainingSurgeryCount);
        });
    }
  }

  show(idikaSurgery?: IdikaSurgery, hospitalId?: string | null): void {
    this.idikaSurgery = idikaSurgery;
    this.hospitalId = hospitalId;
    this.initForm();
    this.visible = true;

    if (this.hospitalId) {
      this.hospitalAvailabilityService
        .getHospitalAvailabilitiesByHospital(this.hospitalId)
        .subscribe((data) => {
          this.hospitalAvailabilities = data;
        });
    }

    this.messages = [
      {
        severity: 'warn',
        detail:
          'Προσοχή! Για να μπορέσετε να προχωρήσετε σε ανάθεση θα πρέπει το νοσοκομείο να έχει διαθεσιμότητα.',
      },
    ];
  }
}
